import queryString from 'query-string';

export interface ResponseError extends Error {
  status?: number;
}

export type apiFetcherArgs = {
  url: string;
  queryParams?: Record<string, string | number>;
  options?: RequestInit;
  // Defaults to the atlas API (VITE_API_ENDPOINT). Pass SKY_API_ENDPOINT to
  // read sky-api directly.
  baseUrl?: string;
};

// sky-api's atlas-dashboard namespace (sky.data.blockanalitica.com/internal/atlas):
// every sky-api endpoint this app calls is registered there. The Required Risk
// Capital, Actively Stabilizing Collateral and Aggregate Backstop Capital pages
// use it, and so do every circulating USDS/DAI supply figure (see supply.ts),
// the savings totals and utilization (see savings.ts) and the USDS Backed
// Breakdown; the rest of the app still goes through atlas.
export const SKY_API_ENDPOINT: string =
  // @ts-ignore
  import.meta.env.VITE_SKY_API_ENDPOINT ??
  'https://sky.data.blockanalitica.com/internal/atlas';

export default async function apiFetcher<T>({
  url,
  queryParams,
  options,
  baseUrl
}: apiFetcherArgs): Promise<T> {
  let qs: string = '';
  if (queryParams) {
    qs = queryString.stringify(queryParams, {
      skipNull: true,
      skipEmptyString: true
    });
    if (qs) {
      qs = `?${qs}`;
    }
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options?.headers
  };
  const isAtlasApi = baseUrl === undefined;
  if (isAtlasApi) {
    // atlas-only header; never sent to sky-api.
    // @ts-ignore
    headers['atlas-restricted'] = import.meta.env.VITE_PUBLIC_RESTRICTED_BUILD;
  }
  const requestOptions: RequestInit = { ...options, headers };

  // @ts-ignore
  const endpoint = baseUrl ?? import.meta.env.VITE_API_ENDPOINT;
  const res = await fetch(`${endpoint}${url}${qs}`, requestOptions);

  if (!res.ok) {
    const error = new Error(
      'An error occurred while fetching the data.'
    ) as ResponseError;
    error.status = res.status;
    throw error;
  }

  return res.json();
}
